import React, { createContext, useState } from "react";
// a user context that will be used to store the user data
export const ACSContext = createContext();

export const ACSProvider = ({ children }) => {
    const [callAgent, setCallAgent] = useState(null);
    const [callClient, setCallClient] = useState(null);
    const [activeCall, setActiveCall] = useState(null);
    const [incomingCall, setIncomingCall] = useState(null);
    const [deviceManager, setDeviceManager] = useState(null);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [videoAvailable, setVideoAvailable] = useState(false);
    const [remoteVideoStream, setRemoteVideoStream] = useState(null);
    const [remoteName, setRemoteName] = useState(null);

      return (
        <ACSContext.Provider value={{
            callAgent, setCallAgent,
            callClient, setCallClient,
            activeCall, setActiveCall,
            incomingCall, setIncomingCall,
            deviceManager, setDeviceManager,
            selectedDevice, setSelectedDevice,
            remoteVideoStream, setRemoteVideoStream,
            videoAvailable, setVideoAvailable,
            remoteName, setRemoteName
         }}>
        {children}
        </ACSContext.Provider>
    );
    };